import { defineMessages } from 'react-intl';

export default defineMessages({
    enterYourDetailsHeader: {
        id: 'enrollment.components.enrollment.Link a Policy',
        defaultMessage: 'Link a Policy',
    },
    enroll: {
        id: 'enrollment.components.enrollment.Submit',
        defaultMessage: 'Submit',
    },
    enrollmentAddressLine1: {
        id: 'enrollment.components.enrollment.Address Line 1:',
        defaultMessage: 'Address Line 1:',
    },
    mailingAddressZipCode: {
        id: 'enrollment.components.enrollment.Mailing Address Zip Code:',
        defaultMessage: 'Mailing Address Zip Code:',
    },
    enrollmentPolicyOrOfferNumber: {
        id: 'enrollment.components.enrollment.Policy Number/Offer Number:',
        defaultMessage: 'Policy Number/Offer Number:',
    },
    returnToHomePage: {
        id: 'enrollment.components.enrollment.Return to Home Page',
        defaultMessage: 'Return to Home Page',
    },
    enrollmentFailedTWIA: {
        id: 'enrollment.components.enrollment.The offer/policy number is not a TWIA number.',
        defaultMessage: 'The offer/policy number is not a TWIA number.',
    },
    enrollmentFailedTFPA: {
        id: 'enrollment.components.enrollment.The policy number is not a TFPA number.',
        defaultMessage: 'The policy number is not a TFPA number.',
    },
    enrollmentFailed: {
        id: 'enrollment.components.enrollment.Sorry we cannot process your enrollment request at this time',
        defaultMessage: 'Sorry we cannot process your enrollment request at this time',
    },
    enrollmentInvalid: {
        id: 'enrollment.components.enrollment.Sorry your enrollment request is invalid',
        defaultMessage: 'Sorry your enrollment request is invalid',
    },
    enrollmentSuccess: {
        id: 'enrollment.components.enrollment.Enrollment Successful',
        defaultMessage: 'Enrollment Successful',
    },
    fieldEmpty: {
        id: 'enrollment.components.enrollment.All fields are required to link a policy or offer.',
        defaultMessage: 'All fields are required to link a policy or offer.',
    },
    accessToYourPolicies: {
        id: 'enrollment.components.enrollment.You now have access to your policies:',
        defaultMessage: 'You now have access to your policies:',
    },
    accessToYourPolicy: {
        id: 'enrollment.components.enrollment.You now have access to your policy:',
        defaultMessage: 'You now have access to your policy:',
    },
    enrollmentSuccessHeader: {
        id: 'enrollment.components.enrollment.Policy Successfully Linked',
        defaultMessage: 'Policy Successfully Linked',
    },
    enrollmentSuccessBody: {
        id: 'enrollment.components.enrollment.This {policyOrOffer} has been linked to your account: {policyOrOfferNumber}',
        defaultMessage: 'This {policyOrOffer} has been linked to your account: {policyOrOfferNumber}. You must login again to see your policies.',
    },
    modalCancelText: {
        id: 'enrollment.components.enrollment.Close',
        defaultMessage: 'Close'
    },
    formatErrorTitle: {
        id: 'enrollment.components.enrollment.The policy/offer number format is incorrect.',
        defaultMessage: 'The policy/offer number format is incorrect.'
    },
    formatErrorTitleTFPA: {
        id: 'enrollment.components.enrollment.The policy number format is incorrect.',
        defaultMessage: 'The policy number format is incorrect.'
    },
    formatErrorMessage: {
        id: 'enrollment.components.enrollment.Please enter your full 14 character TWIA policy number, including the letters, (e.g., TWRD0100012345), or the 10 digit offer number (e.g., 1234567890)',
        defaultMessage: 'Please enter your full 14 character TWIA policy number, including the letters, (e.g., TWRD0100012345), or the 10 digit offer number (e.g., 1234567890)'
    },
    formatErrorMessageTFPA: {
        id: 'enrollment.components.enrollment.Please enter your full 14 character TFPA policy number, including the letters, (e.g., TFPA0100012345)',
        defaultMessage: 'Please enter your full 14 character TFPA policy number, including the letters, (e.g., TFPA0100012345)'
    },
    invalidDataErrorTitle: {
        id: 'enrollment.components.enrollment.Invalid Data',
        defaultMessage: 'Invalid Data'
    },
    invalidDataErrorMessage: {
        id: 'enrollment.components.enrollment.The information entered could not be found.',
        defaultMessage: 'The information entered could not be found.'
    },
    invalidDataDuplicateErrorTitle: {
        id: 'enrollment.components.enrollment.Error',
        defaultMessage: 'Error'
    },
    invalidDataDuplicateErrorMessage: {
        id: 'enrollment.components.enrollment.This policy/offer {policyOrOfferNumber} is already linked to a TWIA account. Please contact TWIA at (800) 788-8247',
        defaultMessage: 'This policy/offer {policyOrOfferNumber} is already linked to a TWIA account. Please contact TWIA at (800) 788-8247'
    },
    invalidDataDuplicateErrorMessageTFPA: {
        id: 'enrollment.components.enrollment.This policy {policyOrOfferNumber} is already linked to a TFPA account. Please contact TFPA at (800) 788-8247',
        defaultMessage: 'This policy {policyOrOfferNumber} is already linked to a TFPA account. Please contact TFPA at (800) 788-8247'
    },
    policyNumberOrOfferNumTooltipText: {
        id: 'enrollment.components.enrollment.Please enter your full 14 character policy number, including the letters, (e.g., TWRD0100012345), or the 10 digit offer number (e.g., 1234567890)',
        defaultMessage: 'Please enter your full 14 character policy number, including the letters, (e.g., TWRD0100012345), or the 10 digit offer number (e.g., 1234567890)'
    },
    policyNumberTooltipTextTFPA: {
        id: 'enrollment.components.enrollment.Please enter your full 14 character policy number, including the letters, (e.g., TWRD0100012345)',
        defaultMessage: 'Please enter your full 14 character policy number, including the letters, (e.g., TWRD0100012345)'
    },
    mailingAddressZipTooltipText: {
        id: 'enrollment.components.enrollment.5-digit ZIP code for the mailing address.',
        defaultMessage: '5-digit ZIP code for the mailing address.'
    },
    policyNumberLabel: {
        id: 'enrollment.components.enrollment.Policy Number:',
        defaultMessage: 'Policy Number:'
    },
});
